import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "spacer" }, null, -1)
const _hoisted_3 = {
  id: "colors",
  class: "colorsDesktop"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "centerbox" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://clarkinteractive.com",
  target: "_blank"
}, "Clark Interactive", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "icon" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Intro", -1)
const _hoisted_16 = { class: "content" }
const _hoisted_17 = { class: "centerbox" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { class: "ion-text-center ion-margin-top" }
const _hoisted_25 = { class: "title" }
const _hoisted_26 = { class: "icon" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "TylerClark.AI", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1)
const _hoisted_29 = { class: "title" }
const _hoisted_30 = { class: "icon" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Jetfoiler", -1)
const _hoisted_32 = { class: "content" }
const _hoisted_33 = { class: "project-description" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Jetfoiler", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Bluetooth"),
  /*#__PURE__*/_createElementVNode("li", null, "MapBox integration"),
  /*#__PURE__*/_createElementVNode("li", null, "Offline capabilities"),
  /*#__PURE__*/_createElementVNode("li", null, "Login area"),
  /*#__PURE__*/_createElementVNode("li", null, "Admin area"),
  /*#__PURE__*/_createElementVNode("li", null, "iOS app"),
  /*#__PURE__*/_createElementVNode("li", null, "Android app"),
  /*#__PURE__*/_createElementVNode("li", null, "Dark mode"),
  /*#__PURE__*/_createElementVNode("li", null, "Desktop and mobile")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://jetfoiler.com",
  target: "_blank",
  class: "button"
}, "Website", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://app.jetfoiler.com",
  target: "_blank",
  class: "button"
}, "Web App", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://apps.apple.com/us/app/jetfoiler/id1555588917",
  target: "_blank",
  class: "button"
}, "iOS App", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://play.google.com/store/apps/details?id=com.kaiconcepts.Jetfoiler",
  target: "_blank",
  class: "button"
}, "Android App", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = { class: "swipe" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/jetfoiler1.png" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/jetfoiler2.png" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/jetfoiler3.png" }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/jetfoiler4.png" }, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/jetfoiler5.png" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1)
const _hoisted_50 = { class: "title" }
const _hoisted_51 = { class: "icon" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Umbrella Vet", -1)
const _hoisted_53 = { class: "content" }
const _hoisted_54 = { class: "project-description" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Umbrella Vet", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Real-time video conferencing"),
  /*#__PURE__*/_createElementVNode("li", null, "OpenAI ChatGPT-4 bot"),
  /*#__PURE__*/_createElementVNode("li", null, "Login area"),
  /*#__PURE__*/_createElementVNode("li", null, "Admin area"),
  /*#__PURE__*/_createElementVNode("li", null, "Stripe integration"),
  /*#__PURE__*/_createElementVNode("li", null, "iOS app"),
  /*#__PURE__*/_createElementVNode("li", null, "Android app"),
  /*#__PURE__*/_createElementVNode("li", null, "Dark mode"),
  /*#__PURE__*/_createElementVNode("li", null, "Desktop and mobile")
], -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://umbrella.vet",
  target: "_blank",
  class: "button"
}, "Website", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://apps.apple.com/us/app/umbrella-vet-care-on-demand/id1622284281",
  target: "_blank",
  class: "button"
}, "iOS App", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://play.google.com/store/apps/details?id=com.umbrella.vet",
  target: "_blank",
  class: "button"
}, "Android App", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_63 = { class: "swipe" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/umbrella1.png" }, null, -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/umbrella2.png" }, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/umbrella3.png" }, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/umbrella4.png" }, null, -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/umbrella5.png" }, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1)
const _hoisted_70 = { class: "title" }
const _hoisted_71 = { class: "icon" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Bal", -1)
const _hoisted_73 = { class: "content" }
const _hoisted_74 = { class: "project-description" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Bal Finance", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Login area"),
  /*#__PURE__*/_createElementVNode("li", null, "Plaid integration"),
  /*#__PURE__*/_createElementVNode("li", null, "iOS app"),
  /*#__PURE__*/_createElementVNode("li", null, "Android app"),
  /*#__PURE__*/_createElementVNode("li", null, "Dark mode")
], -1)
const _hoisted_77 = { class: "swipe" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/bal1.png" }, null, -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/bal2.png" }, null, -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/bal3.png" }, null, -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/bal4.png" }, null, -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1)
const _hoisted_83 = { class: "title" }
const _hoisted_84 = { class: "icon" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Boat Meetup", -1)
const _hoisted_86 = { class: "content" }
const _hoisted_87 = { class: "project-description" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Boat Meetup", -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Real-time GPS location tracking"),
  /*#__PURE__*/_createElementVNode("li", null, "Social networking"),
  /*#__PURE__*/_createElementVNode("li", null, "Login area"),
  /*#__PURE__*/_createElementVNode("li", null, "Google Maps integration"),
  /*#__PURE__*/_createElementVNode("li", null, "iOS app"),
  /*#__PURE__*/_createElementVNode("li", null, "Android app"),
  /*#__PURE__*/_createElementVNode("li", null, "Dark mode")
], -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://boatmeetup.com",
  target: "_blank",
  class: "button"
}, "Visit Website", -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_92 = { class: "swipe" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/boatmeetup1.png" }, null, -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/boatmeetup2.png" }, null, -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/boatmeetup3.png" }, null, -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/boatmeetup4.png" }, null, -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/boatmeetup5.png" }, null, -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1)
const _hoisted_99 = { class: "title" }
const _hoisted_100 = { class: "icon" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Wing Ratings", -1)
const _hoisted_102 = { class: "content" }
const _hoisted_103 = { class: "project-description" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Wing Ratings", -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Login area"),
  /*#__PURE__*/_createElementVNode("li", null, "Admin area"),
  /*#__PURE__*/_createElementVNode("li", null, "Google Maps integration"),
  /*#__PURE__*/_createElementVNode("li", null, "iOS app"),
  /*#__PURE__*/_createElementVNode("li", null, "Android app"),
  /*#__PURE__*/_createElementVNode("li", null, "Desktop and mobile")
], -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_107 = { class: "swipe" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/wingratings1.png" }, null, -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/wingratings2.png" }, null, -1)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/wingratings3.png" }, null, -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1)
const _hoisted_112 = { class: "title" }
const _hoisted_113 = { class: "icon" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Tailjoy", -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "centerbox" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Tailjoy"),
    /*#__PURE__*/_createTextVNode(" Coming soon! ")
  ])
], -1)
const _hoisted_116 = { class: "title" }
const _hoisted_117 = {
  key: 0,
  class: "icon"
}
const _hoisted_118 = {
  key: 1,
  class: "icon"
}
const _hoisted_119 = {
  key: 2,
  class: "text"
}
const _hoisted_120 = {
  key: 3,
  class: "text goback"
}
const _hoisted_121 = /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1)
const _hoisted_122 = { class: "title" }
const _hoisted_123 = { class: "icon" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Mobile Apps", -1)
const _hoisted_125 = { class: "content" }
const _hoisted_126 = { class: "centerbox" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Mobile Apps", -1)
const _hoisted_128 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_129 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "pills" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Ionic"),
  /*#__PURE__*/_createElementVNode("div", null, "Capacitor"),
  /*#__PURE__*/_createElementVNode("div", null, "Xcode"),
  /*#__PURE__*/_createElementVNode("div", null, "Android Studio"),
  /*#__PURE__*/_createElementVNode("div", null, "Expo"),
  /*#__PURE__*/_createElementVNode("div", null, "React Native")
], -1)
const _hoisted_131 = /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1)
const _hoisted_132 = { class: "title" }
const _hoisted_133 = { class: "icon" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Salesforce", -1)
const _hoisted_135 = { class: "content" }
const _hoisted_136 = { class: "centerbox" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Salesforce", -1)
const _hoisted_138 = /*#__PURE__*/_createElementVNode("div", { class: "pills" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Apex"),
  /*#__PURE__*/_createElementVNode("div", null, "LWC"),
  /*#__PURE__*/_createElementVNode("div", null, "Aura"),
  /*#__PURE__*/_createElementVNode("div", null, "Visualforce"),
  /*#__PURE__*/_createElementVNode("div", null, "SLDS"),
  /*#__PURE__*/_createElementVNode("div", null, "SFDX")
], -1)
const _hoisted_139 = /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1)
const _hoisted_140 = { class: "title" }
const _hoisted_141 = { class: "icon" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "A.I.", -1)
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "centerbox" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "header" }, "A.I."),
    /*#__PURE__*/_createTextVNode(" I've been working with A.I. since 2016 when I started working with the Salesforce Einstein team on random projects. I've worked on a number of A.I. projects since then, including ChatGPT, Bard, PaLM, Llama, and open source LLMs. "),
    /*#__PURE__*/_createElementVNode("div", { class: "pills" }, [
      /*#__PURE__*/_createElementVNode("div", null, "ChatGPT"),
      /*#__PURE__*/_createElementVNode("div", null, "Google Bard"),
      /*#__PURE__*/_createElementVNode("div", null, "PaLM"),
      /*#__PURE__*/_createElementVNode("div", null, "Llama"),
      /*#__PURE__*/_createElementVNode("div", null, "Custom LLMs")
    ]),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Check out this recent project I completed: "),
    /*#__PURE__*/_createElementVNode("div", { class: "ion-text-center ion-margin-top" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://umbrella.vet",
        target: "_blank",
        class: "button"
      }, "Umbrella AI")
    ])
  ])
], -1)
const _hoisted_144 = /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1)
const _hoisted_145 = { class: "title" }
const _hoisted_146 = { class: "icon" }
const _hoisted_147 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Cloud Platforms", -1)
const _hoisted_148 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "centerbox" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Cloud Platforms"),
    /*#__PURE__*/_createTextVNode(" As a long-time Salesforce dev, I spent almost a decade working for the company who coined \"the cloud.\" So naturally I'm a big fan of all cloud platforms and their ability to scale and provide a great developer experiences."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" I primarily use Google Firebase and Google Cloud because it does everything from hosting, database, messaging, functions, authentication, and more. I also use Supabase for a similar experience with Postgre."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" I've also used AWS, AppFlow, Heroku, Vercel, Netlify, and more. "),
    /*#__PURE__*/_createElementVNode("div", { class: "pills" }, [
      /*#__PURE__*/_createElementVNode("div", null, "Firebase"),
      /*#__PURE__*/_createElementVNode("div", null, "Supabase"),
      /*#__PURE__*/_createElementVNode("div", null, "AWS"),
      /*#__PURE__*/_createElementVNode("div", null, "AppFlow"),
      /*#__PURE__*/_createElementVNode("div", null, "Salesforce"),
      /*#__PURE__*/_createElementVNode("div", null, "Vercel"),
      /*#__PURE__*/_createElementVNode("div", null, "Netlify")
    ])
  ])
], -1)
const _hoisted_149 = /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1)
const _hoisted_150 = { class: "title" }
const _hoisted_151 = { class: "icon" }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Websites", -1)
const _hoisted_153 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "centerbox" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Websites"),
    /*#__PURE__*/_createTextVNode(" With both hybrid app development and Salesforce being web-based, web development is the foundation I know the best. Being full-stack, I can do everything from writing database schemas, creating amazing UI/UX, coding complex backend API's, writing unit tests, and deploying to your favorite cloud provider."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" But if we're talking basics I'm a HTML and CSS wizard and demand that everything looks pixel perfect. "),
    /*#__PURE__*/_createElementVNode("div", { class: "pills" }, [
      /*#__PURE__*/_createElementVNode("div", null, "HTML"),
      /*#__PURE__*/_createElementVNode("div", null, "CSS"),
      /*#__PURE__*/_createElementVNode("div", null, "TypeScript"),
      /*#__PURE__*/_createElementVNode("div", null, "Vue"),
      /*#__PURE__*/_createElementVNode("div", null, "React"),
      /*#__PURE__*/_createElementVNode("div", null, "Nuxt"),
      /*#__PURE__*/_createElementVNode("div", null, "Next")
    ])
  ])
], -1)
const _hoisted_154 = /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1)
const _hoisted_155 = { class: "title" }
const _hoisted_156 = { class: "icon" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Design Systems", -1)
const _hoisted_158 = { class: "content" }
const _hoisted_159 = { class: "centerbox" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Design Systems", -1)
const _hoisted_161 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_162 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_163 = /*#__PURE__*/_createElementVNode("div", { class: "pills" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Lightning Design System"),
  /*#__PURE__*/_createElementVNode("div", null, "Material Design"),
  /*#__PURE__*/_createElementVNode("div", null, "Ionic Framework"),
  /*#__PURE__*/_createElementVNode("div", null, "Bootstrap")
], -1)
const _hoisted_164 = { class: "title" }
const _hoisted_165 = {
  key: 0,
  class: "icon"
}
const _hoisted_166 = {
  key: 1,
  class: "icon"
}
const _hoisted_167 = {
  key: 2,
  class: "text"
}
const _hoisted_168 = {
  key: 3,
  class: "text goback"
}
const _hoisted_169 = { class: "content" }
const _hoisted_170 = { class: "centerbox" }
const _hoisted_171 = {
  class: "socials",
  style: {"float":"right"}
}
const _hoisted_172 = /*#__PURE__*/_createElementVNode("div", { class: "section" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Clark Interactive"),
  /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, "March 2024 - Current"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Co-Founder and CEO"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" We're a consultancy for high-end, enterprise level, pixel-perfect web and mobile apps. "),
      /*#__PURE__*/_createElementVNode("div", { class: "pills" }, [
        /*#__PURE__*/_createElementVNode("div", null, "React"),
        /*#__PURE__*/_createElementVNode("div", null, "Next.js"),
        /*#__PURE__*/_createElementVNode("div", null, "Zod"),
        /*#__PURE__*/_createElementVNode("div", null, "React Native"),
        /*#__PURE__*/_createElementVNode("div", null, "Expo"),
        /*#__PURE__*/_createElementVNode("div", null, "TypeScript")
      ])
    ])
  ])
], -1)
const _hoisted_173 = /*#__PURE__*/_createElementVNode("div", { class: "section" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header" }, "SurveyMonkey"),
  /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, "February 2021 - March 2024"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "CRM Integrations Team"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Team responsbile for Salesforce and Zendesk integrations on the GetFeedback and SurveyMonkey platforms."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" My role: Senior Engineering Manager and architect in-charge of managing engineers and leading product as we expanded our CRM offerings. "),
      /*#__PURE__*/_createElementVNode("div", { class: "pills" }, [
        /*#__PURE__*/_createElementVNode("div", null, "React"),
        /*#__PURE__*/_createElementVNode("div", null, "Python"),
        /*#__PURE__*/_createElementVNode("div", null, "Ruby on Rails"),
        /*#__PURE__*/_createElementVNode("div", null, "Salesforce"),
        /*#__PURE__*/_createElementVNode("div", null, "Lightning Web Components"),
        /*#__PURE__*/_createElementVNode("div", null, "Apex"),
        /*#__PURE__*/_createElementVNode("div", null, "Jira"),
        /*#__PURE__*/_createElementVNode("div", null, "NPM"),
        /*#__PURE__*/_createElementVNode("div", null, "Docker")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Salesforce Team"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Team tasked with all interactions with Salesforce on the GetFeedback platform."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" My role: Architect in-charge of new product developments, mentoring team and maintaining pre-exiting intergrations. "),
      /*#__PURE__*/_createElementVNode("div", { class: "pills" }, [
        /*#__PURE__*/_createElementVNode("div", null, "React"),
        /*#__PURE__*/_createElementVNode("div", null, "Python"),
        /*#__PURE__*/_createElementVNode("div", null, "Ruby on Rails"),
        /*#__PURE__*/_createElementVNode("div", null, "Salesforce"),
        /*#__PURE__*/_createElementVNode("div", null, "Lightning Web Components"),
        /*#__PURE__*/_createElementVNode("div", null, "Apex"),
        /*#__PURE__*/_createElementVNode("div", null, "Jira"),
        /*#__PURE__*/_createElementVNode("div", null, "NPM"),
        /*#__PURE__*/_createElementVNode("div", null, "Docker")
      ])
    ])
  ])
], -1)
const _hoisted_174 = /*#__PURE__*/_createElementVNode("div", { class: "section" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Salesforce"),
  /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, "April 2012 - January 2021; 8 years, 9 months"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Ohana Engineering Team"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Team working within the execuctive branch of Salesforce in-charge of building Salesforce apps for various business units. Also responsbile for apps for the Events, Marketing and Agile teams."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" My role: Lead engineer and team founder in-charge of planning and rolling out new apps on the company's internal Salesforce instance. "),
      /*#__PURE__*/_createElementVNode("div", { class: "pills" }, [
        /*#__PURE__*/_createElementVNode("div", null, "Salesforce"),
        /*#__PURE__*/_createElementVNode("div", null, "Lightning Web Components"),
        /*#__PURE__*/_createElementVNode("div", null, "Apex")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Survey Team"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Initial team that created Salesforce Surveys."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" My role: Lead engineer in-charge of architecting data schemas, creating components on Builder and Recipient UI/UX. Deploying, marketing, and launching of new product offering. "),
      /*#__PURE__*/_createElementVNode("div", { class: "pills" }, [
        /*#__PURE__*/_createElementVNode("div", null, "Salesforce"),
        /*#__PURE__*/_createElementVNode("div", null, "Lightning Web Components"),
        /*#__PURE__*/_createElementVNode("div", null, "Apex")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Components Team"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Initial team that created Lightning Web Components (Codenamed Raptor)."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" My role: Turn SLDS components into interactive components and architect how these components will be versioned and supported for decades to come. "),
      /*#__PURE__*/_createElementVNode("div", { class: "pills" }, [
        /*#__PURE__*/_createElementVNode("div", null, "Salesforce"),
        /*#__PURE__*/_createElementVNode("div", null, "JavaScript"),
        /*#__PURE__*/_createElementVNode("div", null, "Lightning Design System"),
        /*#__PURE__*/_createElementVNode("div", null, "CSS")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Aura Styling Team/Lightning Design System Team"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("Team tasked with going behind other teams and cleaning up code and making sure all parts of Salesforce had a uniforn design matching the Salesforce Design System."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" My role: Checking out new features and making front-end changes where needed. "),
      /*#__PURE__*/_createElementVNode("div", { class: "pills" }, [
        /*#__PURE__*/_createElementVNode("div", null, "Salesforce"),
        /*#__PURE__*/_createElementVNode("div", null, "JavaScript"),
        /*#__PURE__*/_createElementVNode("div", null, "CSS")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "GUS Team"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Team tasked with developing all Agile tools within the organization."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" My role: Lead engineer who created all front-end UI/UX for Kanban, Sprint and Agile tools. "),
      /*#__PURE__*/_createElementVNode("div", { class: "pills" }, [
        /*#__PURE__*/_createElementVNode("div", null, "React")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Accolades & Accomplishments"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 3 time presenter at Dreamforce, 6 time Hack Day winner, 3 patent pending apps created. Speech given with co-founder of the company, Parker Harris, debuting a brand new tool I built from the ground up. Created and presented a Quick Ramp Series and GUS New Hire Presentation. Re-did marketing for entire department, including e-mail and website. ")
    ])
  ])
], -1)
const _hoisted_175 = { class: "title" }
const _hoisted_176 = { class: "icon" }
const _hoisted_177 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Resume", -1)
const _hoisted_178 = { class: "title" }
const _hoisted_179 = { class: "icon" }
const _hoisted_180 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Contact", -1)
const _hoisted_181 = { class: "content" }
const _hoisted_182 = { class: "centerbox" }
const _hoisted_183 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Contact", -1)
const _hoisted_184 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_185 = ["href"]
const _hoisted_186 = {
  key: 0,
  class: "emCopied"
}
const _hoisted_187 = /*#__PURE__*/_createElementVNode("div", { class: "stalkme" }, "You can also stalk me on the socials:", -1)
const _hoisted_188 = {
  target: "_blank",
  href: "https://twitter.com/tylerclark"
}
const _hoisted_189 = {
  target: "_blank",
  href: "https://www.linkedin.com/in/tylerclark/"
}
const _hoisted_190 = {
  target: "_blank",
  href: "https://www.youtube.com/@tclark"
}
const _hoisted_191 = {
  target: "_blank",
  href: "https://github.com/tylerclark"
}
const _hoisted_192 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "centerbox" }, [
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("b", null, "Privacy Policy"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" Effective Date: 2/1/2023"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" This privacy policy outlines how we collect, use, and protect information about you when you use our app. By using our app, you consent to this privacy policy."),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("b", null, "What Information We Collect"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" We do not collect any personal information from you when you use our app. We do not collect your name, email address, phone number, or any other personally identifiable information."),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" We may collect non-personal information about your device, such as your device type, operating system, and internet browser. This information is used to improve our app and provide a better user experience."),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("b", null, "How We Use Your Information"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" We do not use any personal information that we do not collect. We do not sell, rent, or share any information with third parties."),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" We may use non-personal information to analyze how our app is being used and to improve our app. We may also use non-personal information for research and analytics purposes."),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("b", null, "How We Protect Your Information"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" We take reasonable measures to protect the information we collect from you. We use industry-standard security measures to prevent unauthorized access to your information."),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" However, no security system is completely foolproof. We cannot guarantee the security of your information."),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("b", null, "Links to Other Websites"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" Our app may contain links to other websites that are not owned or controlled by us. We are not responsible for the privacy practices of these websites."),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("b", null, "Changes to This Privacy Policy"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" We may update this privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on our website."),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("b", null, "Contact Us"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" If you have any questions or concerns about this privacy policy, please contact us. ")
      ])
    ])
  ])
], -1)
const _hoisted_193 = [
  _hoisted_192
]

import { IonContent, IonPage } from "@ionic/vue";
import { ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";

import { Pagination } from "swiper";

export default /*#__PURE__*/_defineComponent({
  __name: 'MainScreen',
  setup(__props) {

const modules = [Pagination];

const user = ref("tyler");
const domain = ref("tylerclark");
const tld = ref("com");

const email = ref<string>("Verifying you're not a bot...");
const mailToLink = ref<string | undefined>(undefined);
const emailText = ref<string>("");
setTimeout(() => {
  email.value = `${user.value}@${domain.value}.${tld.value}`;
  mailToLink.value = `mailto:${email.value}`;
}, 5000);

// const copyEmail = () => {
//   navigator.clipboard.writeText(email.value);
//   emailText.value = "E-mail copied to your clipboard!";
// };

const sectionTitle = ref<string>("");
const breadcrumbs = ref<any>([]); // TODO: type this

// const color = ["red", "green", "blue", "purple"];
// const color = ["blue"];
// let index = Math.floor(Math.random() * color.length);
// const index = Math.floor(Math.random() * color.length);
// const random = ref<string>(color[index]);
// const random = "blue";
const random = ref<string>("blue");

// setInterval(() => {
//   index = index === color.length - 1 ? 0 : index + 1;
//   random.value = color[index];
// }, 15000);

const gridClass = ref<any>(null);
const innerGridClass = ref<any>(null);
const hiddenScreenClass = ref<any>(null);

const computeBreadcrumbs = (path: string) => {
  if (path === "/") {
    breadcrumbs.value = [];
    return;
  }
  const pathArray = path.split("/");
  breadcrumbs.value = [];
  pathArray.forEach((item: any, index: number) => {
    if (item === "") return;

    let fullPath = "";
    for (let i = 1; i <= index; i++) {
      fullPath += "/" + pathArray[i];
    }
    if (Object.getOwnPropertyDescriptor(navigation, fullPath)) {
      breadcrumbs.value.push({
        last: index === pathArray.length - 1,
        path: fullPath,
        title: navigation[fullPath as keyof typeof navigation].title,
      });
    }
  });
};

const goBackOneBreadcrumb = (path: string) => {
  let crumbs = [] as any;
  if (path === "/") {
    crumbs = [];
    return;
  }
  const pathArray = path.split("/");
  crumbs = [];
  pathArray.forEach((item: any, index: number) => {
    if (item === "") return;

    let fullPath = "";
    for (let i = 1; i <= index; i++) {
      fullPath += "/" + pathArray[i];
    }
    if (Object.getOwnPropertyDescriptor(navigation, fullPath)) {
      crumbs.push(fullPath);
    }
  });
  let parentUrl = crumbs[crumbs.length - 2];
  if (parentUrl === undefined) parentUrl = "/";
  changer(
    {
      path: parentUrl,
      title: navigation[parentUrl as keyof typeof navigation].title,
      gridClassName: navigation[parentUrl as keyof typeof navigation].gridClassName,
      innerGridClassName: navigation[parentUrl as keyof typeof navigation].innerGridClassName,
    },
    false
  );
};

const changer = (obj: any, goBack: boolean) => {
  if (obj.hiddenUrl) {
    sectionTitle.value = obj.title;
    document.title = obj.title;
    gridClass.value = "hide";
    innerGridClass.value = null;
    history.pushState("", "", obj.path);
    hiddenScreenClass.value = "hiddenScreen";
    return;
  }

  if (obj.path === window.location.pathname && goBack) {
    goBackOneBreadcrumb(obj.path);
    return;
  }

  // console.log(
  //   "changer" +
  //     "\n* path: " +
  //     obj.path +
  //     "\n* title: " +
  //     obj.title +
  //     "\n* gridClassName: " +
  //     obj.gridClassName +
  //     "\n* innerGridClassName: " +
  //     obj.innerGridClassName
  // );

  hiddenScreenClass.value = "hide";

  if (obj.gridClassName !== null && obj.innerGridClassName !== null) {
    // go forward
    // console.log(0);
    computeBreadcrumbs(obj.path);
    sectionTitle.value = "";
    document.title = obj.title;
    gridClass.value = obj.gridClassName;
    innerGridClass.value = obj.innerGridClassName;
    history.pushState("", "", obj.path);
  } else if (obj.gridClassName !== null && gridClass.value === obj.gridClassName) {
    // go back
    // console.log(1);
    computeBreadcrumbs(obj.path);
    gridClass.value = obj.gridClassName;
    innerGridClass.value = null;
    document.title = obj.title;
    history.pushState("", "", obj.path);
  } else if (obj.gridClassName !== null && obj.innerGridClassName === null && gridClass.value !== obj.gridClassName) {
    // go forward
    // console.log(2);
    computeBreadcrumbs(obj.path);
    sectionTitle.value = obj.title;
    document.title = obj.title;
    gridClass.value = obj.gridClassName;
    history.pushState("", "", obj.path);
  } else if (obj.innerGridClassName !== null && innerGridClass.value === obj.innerGridClassName) {
    // go back
    // console.log(3);
    innerGridClass.value = "";
    history.pushState("", "", obj.path);
  } else if (obj.gridClassName === null && obj.innerGridClassName !== null) {
    // go forward
    // console.log(4);
    sectionTitle.value = obj.title;
    document.title = obj.title;
    innerGridClass.value = obj.innerGridClassName;
    history.pushState("", "", obj.path);
  } else {
    // console.log(5);
    computeBreadcrumbs(obj.path);
    sectionTitle.value = "";
    document.title = obj.title;
    gridClass.value = obj.gridClassName;
    innerGridClass.value = obj.innerGridClassName;
    history.pushState("", "", obj.path);
  }
  // console.log(" ");
};

const navigation = {
  "/": {
    title: "Tyler Clark / Software Architect",
    gridClassName: null,
    innerGridClassName: null,
  },
  "/intro": {
    title: "Intro",
    gridClassName: "active box1selected",
    innerGridClassName: null,
  },
  "/ai": {
    title: "TylerClark.AI",
    gridClassName: "active box2selected",
    innerGridClassName: null,
  },
  "/portfolio": {
    title: "Portfolio",
    gridClassName: "active box3selected",
    innerGridClassName: null,
  },
  "/portfolio/jetfoiler": {
    title: "Jetfoiler",
    gridClassName: "active box3selected",
    innerGridClassName: "active box1selected",
  },
  "/portfolio/umbrella-vet": {
    title: "Umbrella Vet",
    gridClassName: "active box3selected",
    innerGridClassName: "active box2selected",
  },
  "/portfolio/bal": {
    title: "Bal",
    gridClassName: "active box3selected",
    innerGridClassName: "active box3selected",
  },
  "/portfolio/boat-meetup": {
    title: "Boat Meetup",
    gridClassName: "active box3selected",
    innerGridClassName: "active box4selected",
  },
  // "/portfolio/spurriers": {
  //   title: "Spurriers",
  //   gridClassName: "active box2selected",
  //   innerGridClassName: "active box3selected",
  // },
  "/portfolio/wing-ratings": {
    title: "Wing Ratings",
    gridClassName: "active box3selected",
    innerGridClassName: "active box5selected",
  },
  "/portfolio/tailjoy": {
    title: "Tailjoy",
    gridClassName: "active box3selected",
    innerGridClassName: "active box6selected",
  },
  // "/portfolio/salesforce": {
  //   title: "Salesforce",
  //   gridClassName: "active box2selected",
  //   innerGridClassName: "active box8selected",
  // },
  "/tech": {
    title: "Tech Skills",
    gridClassName: "active box4selected",
    innerGridClassName: null,
  },
  "/tech/apps": {
    title: "Mobile Apps",
    gridClassName: "active box4selected",
    innerGridClassName: "active box1selected",
  },
  "/tech/salesforce": {
    title: "Salesforce",
    gridClassName: "active box4selected",
    innerGridClassName: "active box2selected",
  },
  "/tech/ai": {
    title: "A.I.",
    gridClassName: "active box4selected",
    innerGridClassName: "active box3selected",
  },
  "/tech/cloud-platforms": {
    title: "Cloud Platforms",
    gridClassName: "active box4selected",
    innerGridClassName: "active box4selected",
  },
  "/tech/websites": {
    title: "Websites",
    gridClassName: "active box4selected",
    innerGridClassName: "active box5selected",
  },
  "/tech/design-systems": {
    title: "Design Systems",
    gridClassName: "active box4selected",
    innerGridClassName: "active box6selected",
  },
  "/resume": {
    title: "Resume of Tyler K Clark",
    gridClassName: "active box5selected",
    innerGridClassName: null,
  },
  "/contact": {
    title: "Contact",
    gridClassName: "active box6selected",
    innerGridClassName: null,
  },
  "/privacy": {
    hiddenUrl: true,
    hiddenClass: "privacyScreen",
    title: "Privacy Policy",
    gridClassName: null,
    innerGridClassName: null,
  },
  "/login": {
    hiddenUrl: true,
    hiddenClass: "loginScreen",
    title: "Client Login",
    gridClassName: null,
    innerGridClassName: null,
  },
};

const go = (path: string, goBack: boolean) => {
  // console.log("go: " + path);
  if (Object.getOwnPropertyDescriptor(navigation, path)) {
    const obj = navigation[path as keyof typeof navigation];
    changer({ path: path, ...obj }, goBack);
  }
};

go(window.location.pathname, false);

return (_ctx: any,_cache: any) => {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), {
        "scroll-x": false,
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            id: "holder",
            class: _normalizeClass(random.value)
          }, [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  style: {"background":"#ee453f"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (random.value = 'red')),
                  class: _normalizeClass(random.value === 'red' ? 'active' : '')
                }, null, 2),
                _createElementVNode("div", {
                  style: {"background":"#9a57ef"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (random.value = 'purple')),
                  class: _normalizeClass(random.value === 'purple' ? 'active' : '')
                }, null, 2),
                _createElementVNode("div", {
                  style: {"background":"#54a3f0"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (random.value = 'blue')),
                  class: _normalizeClass(random.value === 'blue' ? 'active' : '')
                }, null, 2),
                _createElementVNode("div", {
                  style: {"background":"#61c6c7"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (random.value = 'teal')),
                  class: _normalizeClass(random.value === 'teal' ? 'active' : '')
                }, null, 2),
                _createElementVNode("div", {
                  style: {"background":"#58f05d"},
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (random.value = 'green')),
                  class: _normalizeClass(random.value === 'green' ? 'active' : '')
                }, null, 2)
              ]),
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("span", null, "Tyler Clark / Software Architect", 512), [
                  [_vShow, !innerGridClass.value && !gridClass.value]
                ]),
                _withDirectives(_createElementVNode("span", {
                  "data-clickable": "true",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (go('/', true)), ["stop"]))
                }, [
                  _createVNode(_component_fa, {
                    icon: "home",
                    type: "fas"
                  })
                ], 512), [
                  [_vShow, innerGridClass.value || gridClass.value]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbs.value, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.path
                  }, [
                    _createVNode(_component_fa, {
                      icon: "chevron-right",
                      type: "fas",
                      class: "arrow-show"
                    }),
                    (!item.last)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          "data-clickable": "true",
                          onClick: _withModifiers(($event: any) => (go(item.path, true)), ["stop"])
                        }, _toDisplayString(item.title), 9, _hoisted_4))
                      : _createCommentVNode("", true),
                    (item.last)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.title), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["grid grid6", gridClass.value])
            }, [
              _createElementVNode("div", {
                id: "section_intro",
                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (go('/intro', true)), ["stop"]))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createTextVNode(" Hello, my name is Tyler Clark. I am a former software architect with over 28 years of experience in the web industry. Currently, I am the founder and CEO at "),
                      _hoisted_8,
                      _createTextVNode(" - A really cool web/app development company."),
                      _hoisted_9,
                      _hoisted_10,
                      _createTextVNode(" I began my journey in the late 90's and have since honed my skills to become a leading expert in web and mobile app development. I am particularly proud of my tenure at the "),
                      _createElementVNode("a", {
                        href: "https://www.nytimes.com",
                        target: "_blank",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                      }, "New York Times"),
                      _createTextVNode(" working on high-traffic dynamic websites and "),
                      _createElementVNode("a", {
                        href: "https://www.salesforce.com",
                        target: "_blank",
                        onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                      }, "Salesforce"),
                      _createTextVNode(" where I spent almost a decade working on cutting-edge projects."),
                      _hoisted_11,
                      _hoisted_12,
                      _createTextVNode(" Throughout my career, I've had the opportunity to work on thousands of websites and mobile apps, each one a testament to my dedication to creating high-quality, user-friendly solutions. ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_fa, {
                          icon: "hand-wave",
                          type: "fas"
                        })
                      ]),
                      _hoisted_15
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", {
                id: "section_ai",
                onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (go('/ai', true)), ["stop"]))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createTextVNode(" I'm very excited about the future of Artificial Intelligence and Machine Learning. Lately, I've been experimenting with agents and team agents. I love OpenAI's GPTs and open source LLama and have been blown away by the results. In addition, I've been working with Google's PaLM 3 and Bard models to experiment with key differences in the platforms."),
                      _hoisted_18,
                      _hoisted_19,
                      _createTextVNode(" I've done embeddings in vector stores, fine tuning, vision, TTS, and more."),
                      _hoisted_20,
                      _hoisted_21,
                      _createTextVNode(" If you're looking to create something amazing with AI, I'd love to hear from you!"),
                      _hoisted_22,
                      _hoisted_23,
                      _createTextVNode(" Check out this recent project I completed: "),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("a", {
                          href: "https://umbrella.vet",
                          target: "_blank",
                          class: "button",
                          onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                        }, "Umbrella AI")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_fa, {
                          icon: "robot",
                          type: "fas"
                        })
                      ]),
                      _hoisted_27
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", {
                id: "section_portfolio",
                class: "innerGrid",
                onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (go('/portfolio', true)), ["stop"]))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["content grid grid6", innerGridClass.value])
                  }, [
                    _createElementVNode("div", {
                      id: "prj_jetfoiler",
                      onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (go('/portfolio/jetfoiler', true)), ["stop"]))
                    }, [
                      _hoisted_28,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_30, [
                              _createVNode(_component_fa, {
                                icon: "mobile",
                                type: "fas"
                              }),
                              _createVNode(_component_fa, {
                                icon: "earth-americas",
                                type: "fas"
                              })
                            ]),
                            _hoisted_31
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", {
                            class: "slides",
                            onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createVNode(_unref(Swiper), {
                              "slides-per-view": 1,
                              centeredSlides: true,
                              "space-between": 50,
                              "grab-cursor": true,
                              breakpoints: {
                            '700': {
                              slidesPerView: 2,
                              spaceBetween: 40,
                            },
                            '900': {
                              slidesPerView: 3,
                              spaceBetween: 40,
                            },
                            '1100': {
                              slidesPerView: 4,
                              spaceBetween: 40,
                            },
                          },
                              modules: modules
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_33, [
                                      _hoisted_34,
                                      _createTextVNode(" I worked on this project for over 3 years. What an amazing ride (literally) as this was my first app which talked to a physical device."),
                                      _hoisted_35,
                                      _hoisted_36,
                                      _createTextVNode(" The Jetfoiler is an efoil (electric hydrofoil) which allows you to surf above the water. The app allows you to control the board, view telemetry data, and share your sessions with friends. "),
                                      _hoisted_37,
                                      _hoisted_38,
                                      _hoisted_39,
                                      _hoisted_40,
                                      _hoisted_41,
                                      _hoisted_42,
                                      _createElementVNode("div", _hoisted_43, [
                                        _createVNode(_component_fa, {
                                          icon: "arrow-left",
                                          type: "fas"
                                        }),
                                        _createTextVNode(" Swipe for screenshots ")
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_44
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_45
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_46
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_47
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_48
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      id: "prj_umbrellavet",
                      onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (go('/portfolio/umbrella-vet', true)), ["stop"]))
                    }, [
                      _hoisted_49,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_51, [
                              _createVNode(_component_fa, {
                                icon: "mobile",
                                type: "fas"
                              }),
                              _createVNode(_component_fa, {
                                icon: "earth-americas",
                                type: "fas"
                              })
                            ]),
                            _hoisted_52
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", {
                            class: "slides",
                            onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createVNode(_unref(Swiper), {
                              "slides-per-view": 1,
                              centeredSlides: true,
                              "space-between": 50,
                              "grab-cursor": true,
                              breakpoints: {
                            '700': {
                              slidesPerView: 2,
                              spaceBetween: 40,
                            },
                            '900': {
                              slidesPerView: 3,
                              spaceBetween: 40,
                            },
                            '1100': {
                              slidesPerView: 4,
                              spaceBetween: 40,
                            },
                          },
                              modules: modules
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_54, [
                                      _hoisted_55,
                                      _createTextVNode(" A passion project for me and an opportunity for me to work with an amazing group of people."),
                                      _hoisted_56,
                                      _hoisted_57,
                                      _createTextVNode(" Umbrella Vet is a fantasic app and website combo that blends together many of my favorite features: "),
                                      _hoisted_58,
                                      _hoisted_59,
                                      _hoisted_60,
                                      _hoisted_61,
                                      _hoisted_62,
                                      _createElementVNode("div", _hoisted_63, [
                                        _createVNode(_component_fa, {
                                          icon: "arrow-left",
                                          type: "fas"
                                        }),
                                        _createTextVNode(" Swipe for screenshots ")
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_64
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_65
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_66
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_67
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_68
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      id: "prj_bal",
                      onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (go('/portfolio/bal', true)), ["stop"]))
                    }, [
                      _hoisted_69,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_70, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_71, [
                              _createVNode(_component_fa, {
                                icon: "mobile",
                                type: "fas"
                              })
                            ]),
                            _hoisted_72
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("div", {
                            class: "slides",
                            onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createVNode(_unref(Swiper), {
                              "slides-per-view": 1,
                              centeredSlides: true,
                              "space-between": 50,
                              "grab-cursor": true,
                              breakpoints: {
                            '700': {
                              slidesPerView: 2,
                              spaceBetween: 40,
                            },
                            '900': {
                              slidesPerView: 3,
                              spaceBetween: 40,
                            },
                            '1100': {
                              slidesPerView: 4,
                              spaceBetween: 40,
                            },
                          },
                              modules: modules
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_74, [
                                      _hoisted_75,
                                      _createTextVNode(" This project got it's start when I was looking for an alternative to existing apps on the App Store centered around personal finance and real-time balance tracking. Every app I tried didn't do real-time or they didn't take into account pending balances. So I just made my own! "),
                                      _hoisted_76,
                                      _createElementVNode("div", _hoisted_77, [
                                        _createVNode(_component_fa, {
                                          icon: "arrow-left",
                                          type: "fas"
                                        }),
                                        _createTextVNode(" Swipe for screenshots ")
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_78
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_79
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_80
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_81
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      id: "prj_boatmeetup",
                      onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (go('/portfolio/boat-meetup', true)), ["stop"]))
                    }, [
                      _hoisted_82,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_84, [
                              _createVNode(_component_fa, {
                                icon: "mobile",
                                type: "fas"
                              })
                            ]),
                            _hoisted_85
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("div", {
                            class: "slides",
                            onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createVNode(_unref(Swiper), {
                              "slides-per-view": 1,
                              centeredSlides: true,
                              "space-between": 50,
                              "grab-cursor": true,
                              breakpoints: {
                            '700': {
                              slidesPerView: 2,
                              spaceBetween: 40,
                            },
                            '900': {
                              slidesPerView: 3,
                              spaceBetween: 40,
                            },
                            '1100': {
                              slidesPerView: 4,
                              spaceBetween: 40,
                            },
                          },
                              modules: modules
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_87, [
                                      _hoisted_88,
                                      _createTextVNode(" Another project born from a lack of an existing app to fulfill my needs. I wanted to be able to find my friends on the water or let them know where I was or that I was going boating that day. So I made an app that was equal parts notifying friends and advanced location tracking with privacy in mind. "),
                                      _hoisted_89,
                                      _hoisted_90,
                                      _hoisted_91,
                                      _createElementVNode("div", _hoisted_92, [
                                        _createVNode(_component_fa, {
                                          icon: "arrow-left",
                                          type: "fas"
                                        }),
                                        _createTextVNode(" Swipe for screenshots ")
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_93
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_94
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_95
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_96
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_97
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      id: "prj_wingratings",
                      onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (go('/portfolio/wing-ratings', true)), ["stop"]))
                    }, [
                      _hoisted_98,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_99, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_100, [
                              _createVNode(_component_fa, {
                                icon: "mobile",
                                type: "fas"
                              }),
                              _createVNode(_component_fa, {
                                icon: "earth-americas",
                                type: "fas"
                              })
                            ]),
                            _hoisted_101
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_102, [
                          _createElementVNode("div", {
                            class: "slides",
                            onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createVNode(_unref(Swiper), {
                              "slides-per-view": 1,
                              centeredSlides: true,
                              "space-between": 50,
                              "grab-cursor": true,
                              breakpoints: {
                            '700': {
                              slidesPerView: 2,
                              spaceBetween: 40,
                            },
                            '900': {
                              slidesPerView: 3,
                              spaceBetween: 40,
                            },
                            '1100': {
                              slidesPerView: 4,
                              spaceBetween: 40,
                            },
                          },
                              modules: modules
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_103, [
                                      _hoisted_104,
                                      _createTextVNode(" A just for fun project from one wing lover to another. This project was built to help people find the best wings in their area. It's a simple app that allows users to rate their favorite wings and see what others have rated. It's a great way to find new places to try! "),
                                      _hoisted_105,
                                      _hoisted_106,
                                      _createElementVNode("div", _hoisted_107, [
                                        _createVNode(_component_fa, {
                                          icon: "arrow-left",
                                          type: "fas"
                                        }),
                                        _createTextVNode(" Swipe for screenshots ")
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_108
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_109
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SwiperSlide), null, {
                                  default: _withCtx(() => [
                                    _hoisted_110
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      id: "prj_tailjoy",
                      onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (go('/portfolio/tailjoy', true)), ["stop"]))
                    }, [
                      _hoisted_111,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_112, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_113, [
                              _createVNode(_component_fa, {
                                icon: "mobile",
                                type: "fas"
                              })
                            ]),
                            _hoisted_114
                          ])
                        ]),
                        _hoisted_115
                      ])
                    ])
                  ], 2),
                  _createElementVNode("div", _hoisted_116, [
                    _createElementVNode("div", null, [
                      (!gridClass.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                            _createVNode(_component_fa, {
                              icon: "briefcase",
                              type: "fas"
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (gridClass.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                            _createVNode(_component_fa, {
                              icon: "arrow-left",
                              type: "fas"
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (!gridClass.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_119, "Portfolio"))
                        : _createCommentVNode("", true),
                      (gridClass.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_120, "Go back"))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", {
                id: "section_tech",
                class: "innerGrid",
                onClick: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (go('/tech', true)), ["stop"]))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["content grid grid6", innerGridClass.value])
                  }, [
                    _createElementVNode("div", {
                      id: "tech_mobileapps",
                      onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (go('/tech/apps', true)), ["stop"]))
                    }, [
                      _hoisted_121,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_122, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_123, [
                              _createVNode(_component_fa, {
                                icon: "mobile",
                                type: "fas"
                              })
                            ]),
                            _hoisted_124
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_125, [
                          _createElementVNode("div", _hoisted_126, [
                            _hoisted_127,
                            _createTextVNode(" When I work on mobile apps, I prefer to use "),
                            _createElementVNode("a", {
                              href: "https://ionicframework.com",
                              target: "_blank",
                              onClick: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"]))
                            }, "Ionic/Capacitor"),
                            _createTextVNode(" or Expo/React Native for cross-platform iOS and Android development. This hybrid approach allows me to write code once, publish to native app stores and the web, and keep costs low."),
                            _hoisted_128,
                            _hoisted_129,
                            _createTextVNode(" However, I am a certified iOS developer and have experience with Android too. With successfully published apps in both app stores I can help you no matter what the challenge is. "),
                            _hoisted_130
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      id: "tech_salesforce",
                      onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (go('/tech/salesforce', true)), ["stop"]))
                    }, [
                      _hoisted_131,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_132, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_133, [
                              _createVNode(_component_fa, {
                                icon: "salesforce",
                                type: "fab"
                              })
                            ]),
                            _hoisted_134
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_135, [
                          _createElementVNode("div", _hoisted_136, [
                            _hoisted_137,
                            _createTextVNode(" As a Salesforce Architect with almost a decade of experience working at Salesforce, I'm quite versed in Apex, LWC, Aura and Visualforce. I worked on the team that created Lightning Web Components and collaborated with the team that created the "),
                            _createElementVNode("a", {
                              href: "https://getslds.com/",
                              target: "_blank",
                              onClick: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"]))
                            }, "Salesforce Lightning Design System"),
                            _createTextVNode(" (SLDS) and the "),
                            _createElementVNode("a", {
                              href: "https://developer.salesforce.com/tools/sfdxcli",
                              target: "_blank",
                              onClick: _cache[26] || (_cache[26] = _withModifiers(() => {}, ["stop"]))
                            }, "Salesforce Developer Experience"),
                            _createTextVNode(" (SFDX). "),
                            _hoisted_138
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      id: "tech_ai",
                      onClick: _cache[28] || (_cache[28] = _withModifiers(($event: any) => (go('/tech/ai', true)), ["stop"]))
                    }, [
                      _hoisted_139,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_140, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_141, [
                              _createVNode(_component_fa, {
                                icon: "robot",
                                type: "fas"
                              })
                            ]),
                            _hoisted_142
                          ])
                        ]),
                        _hoisted_143
                      ])
                    ]),
                    _createElementVNode("div", {
                      id: "tech_cloudPlatforms",
                      onClick: _cache[29] || (_cache[29] = _withModifiers(($event: any) => (go('/tech/cloud-platforms', true)), ["stop"]))
                    }, [
                      _hoisted_144,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_145, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_146, [
                              _createVNode(_component_fa, {
                                icon: "cloud",
                                type: "fas"
                              })
                            ]),
                            _hoisted_147
                          ])
                        ]),
                        _hoisted_148
                      ])
                    ]),
                    _createElementVNode("div", {
                      id: "tech_websites",
                      onClick: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (go('/tech/websites', true)), ["stop"]))
                    }, [
                      _hoisted_149,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_150, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_151, [
                              _createVNode(_component_fa, {
                                icon: "earth-americas",
                                type: "fas"
                              })
                            ]),
                            _hoisted_152
                          ])
                        ]),
                        _hoisted_153
                      ])
                    ]),
                    _createElementVNode("div", {
                      id: "tech_designSystems",
                      onClick: _cache[32] || (_cache[32] = _withModifiers(($event: any) => (go('/tech/design-systems', true)), ["stop"]))
                    }, [
                      _hoisted_154,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_155, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_156, [
                              _createVNode(_component_fa, {
                                icon: "paint-roller",
                                type: "fas"
                              })
                            ]),
                            _hoisted_157
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_158, [
                          _createElementVNode("div", _hoisted_159, [
                            _hoisted_160,
                            _createTextVNode(" I helped the original team that created the "),
                            _createElementVNode("a", {
                              href: "https://getslds.com/",
                              target: "_blank",
                              onClick: _cache[31] || (_cache[31] = _withModifiers(() => {}, ["stop"]))
                            }, "Salesforce Lightning Design System"),
                            _createTextVNode(". I then worked for the Components team which took the HTML/CSS designs and converted them into functional Lightning components and then later Lightning Web Components."),
                            _hoisted_161,
                            _hoisted_162,
                            _createTextVNode(" One of my previous managers is now the head of the Material Design team at Google. I've been using Material Design in projects since it's inception. I've also been using the Material Design Components and Material Design Icons in my projects for years. "),
                            _hoisted_163
                          ])
                        ])
                      ])
                    ])
                  ], 2),
                  _createElementVNode("div", _hoisted_164, [
                    _createElementVNode("div", null, [
                      (!gridClass.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                            _createVNode(_component_fa, {
                              icon: "cubes-stacked",
                              type: "fas"
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (gridClass.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                            _createVNode(_component_fa, {
                              icon: "arrow-left",
                              type: "fas"
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (!gridClass.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_167, "Tech Skills"))
                        : _createCommentVNode("", true),
                      (gridClass.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_168, "Go back"))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", {
                id: "section_resume",
                onClick: _cache[35] || (_cache[35] = _withModifiers(($event: any) => (go('/resume', true)), ["stop"]))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_169, [
                    _createElementVNode("div", _hoisted_170, [
                      _createElementVNode("div", _hoisted_171, [
                        _createElementVNode("a", {
                          target: "_blank",
                          href: "https://www.linkedin.com/in/tylerclark/",
                          onClick: _cache[34] || (_cache[34] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _createVNode(_component_fa, {
                            icon: "linkedin",
                            type: "fab"
                          })
                        ])
                      ]),
                      _hoisted_172,
                      _hoisted_173,
                      _hoisted_174
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_175, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_176, [
                        _createVNode(_component_fa, {
                          icon: "file-user",
                          type: "fas"
                        })
                      ]),
                      _hoisted_177
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", {
                id: "section_contact",
                onClick: _cache[38] || (_cache[38] = _withModifiers(($event: any) => (go('/contact', true)), ["stop"]))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_178, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_179, [
                        _createVNode(_component_fa, {
                          icon: "message-middle",
                          type: "fas"
                        })
                      ]),
                      _hoisted_180
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_181, [
                    _createElementVNode("div", _hoisted_182, [
                      _createElementVNode("div", null, [
                        _hoisted_183,
                        _createTextVNode(" The best way to connect with me is via email."),
                        _hoisted_184,
                        _createElementVNode("a", {
                          class: "button em",
                          href: mailToLink.value,
                          onClick: _cache[36] || (_cache[36] = _withModifiers(() => {}, ["stop"])),
                          target: "_blank"
                        }, _toDisplayString(email.value), 9, _hoisted_185),
                        (emailText.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_186, [
                              _createVNode(_component_fa, { icon: "check" }),
                              _createTextVNode(_toDisplayString(emailText.value), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_187,
                      _createElementVNode("div", {
                        class: "socials",
                        onClick: _cache[37] || (_cache[37] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _createElementVNode("a", _hoisted_188, [
                          _createVNode(_component_fa, {
                            icon: "twitter",
                            type: "fab"
                          })
                        ]),
                        _createElementVNode("a", _hoisted_189, [
                          _createVNode(_component_fa, {
                            icon: "linkedin",
                            type: "fab"
                          })
                        ]),
                        _createElementVNode("a", _hoisted_190, [
                          _createVNode(_component_fa, {
                            icon: "youtube",
                            type: "fab"
                          })
                        ]),
                        _createElementVNode("a", _hoisted_191, [
                          _createVNode(_component_fa, {
                            icon: "github",
                            type: "fab"
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ], 2),
            _createElementVNode("div", {
              id: "section_privacy",
              class: _normalizeClass(hiddenScreenClass.value),
              "data-url": "/privacy",
              onClick: _cache[39] || (_cache[39] = _withModifiers(($event: any) => (go('/privacy', true)), ["stop"]))
            }, _hoisted_193, 2)
          ], 2)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})